import { axiosInstance } from './axiosConfig';
import { handleRequestWithAuth } from './refreshService';
import { ConsumoHorasRegalo } from './consumoHorasRegaloService'; // Importar la interfaz

const API_URL = 'uso-horas-regalo/';

// Interfaces para PrecioPlanPermitidoInfo
export interface PrecioPlanPermitidoInfo {
    id: number;
    plan_servicio: string;
    plan: string;
    servicio: string;
    precio_inicial: number;
    precio_posterior?: number | null;
}

// Interfaces principales - ACTUALIZADA
export interface UsoHorasRegalo {
    id: number;
    cliente: number;
    cliente_email: string;
    cliente_nombre: string;
    config_horas_regalo: number;
    config_horas_regalo_display: string;
    Sesion_asociada?: number | null;
    sesion_display?: string;
    afiliacion?: number | null;
    afiliacion_empresa?: string | null;
    horas_usadas: number | null;
    horas_regalo_aplicadas: number;
    excedente_cobrado: string;
    fecha_uso: string | null;
    fecha_inicio_periodo: string;
    fecha_fin_periodo: string;
    precios_plan_permitidos: number[];
    precios_plan_permitidos_info?: PrecioPlanPermitidoInfo[];
    consumos?: ConsumoHorasRegalo[];
    minutos_disponibles?: number;
}

export interface UsoHorasRegaloCreate {
    cliente: number;
    config_horas_regalo: number;
    Sesion_asociada?: number | null;
    afiliacion?: number | null;
    horas_usadas?: number | null;
    horas_regalo_aplicadas: number;
    excedente_cobrado?: string;
    fecha_inicio_periodo: string;
    fecha_fin_periodo: string;
}

export interface ResumenCliente {
    cliente_id: number;
    cliente__email: string;
    cliente__first_name: string;
    cliente__last_name: string;
    total_horas_regalo: number;
    total_excedente: string;
    total_registros: number;
}

// Operaciones CRUD básicas
export const fetchUsoHorasRegalo = async (): Promise<UsoHorasRegalo[]> => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.get(API_URL);
        return response.data;
    });
};

export const createUsoHorasRegalo = async (data: UsoHorasRegaloCreate): Promise<UsoHorasRegalo> => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.post(API_URL, data);
        return response.data;
    });
};

export const updateUsoHorasRegalo = async (id: number, data: Partial<UsoHorasRegaloCreate>): Promise<UsoHorasRegalo> => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.put(`${API_URL}${id}/`, data);
        return response.data;
    });
};

export const deleteUsoHorasRegalo = async (id: number): Promise<void> => {
    return handleRequestWithAuth(async () => {
        await axiosInstance.delete(`${API_URL}${id}/`);
    });
};

export const getUsoHorasRegaloById = async (id: number): Promise<UsoHorasRegalo> => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.get(`${API_URL}${id}/`);
        return response.data;
    });
};

// Filtros y acciones personalizadas
export const fetchUsoHorasRegaloFiltrados = async (filtros: {
    cliente?: number;
    config_horas_regalo?: number;
    afiliacion?: number;
    fecha_inicio?: string;
    fecha_fin?: string;
}): Promise<UsoHorasRegalo[]> => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.get(API_URL, { params: filtros });
        return response.data;
    });
};

export const fetchUsoHorasRegaloPorCliente = async (cliente_id: number): Promise<UsoHorasRegalo[]> => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.get(`${API_URL}por_cliente/?cliente_id=${cliente_id}`);
        return response.data;
    });
};

export const fetchUsoHorasRegaloPorSesion = async (sesion_id: number): Promise<UsoHorasRegalo | null> => {
    return handleRequestWithAuth(async () => {
        try {
            const response = await axiosInstance.get(`${API_URL}por_sesion/?sesion_id=${sesion_id}`);
            return response.data;
        } catch (error: any) {
            if (error.response?.status === 404 || error.response?.status === 200) {
                return null;
            }
            /* Browser diagnostics omitted. */
            throw error;
        }
    });
};

export const fetchUsoHorasRegaloPorAfiliacion = async (afiliacion_id: number): Promise<UsoHorasRegalo | null> => {
    return handleRequestWithAuth(async () => {
        try {
            const response = await axiosInstance.get(`${API_URL}?afiliacion=${afiliacion_id}`);
            const list = response.data?.results || response.data || [];
            return list.length > 0 ? list[0] : null;
        } catch (error: any) {
            /* Browser diagnostics omitted. */
            return null;
        }
    });
};

export const fetchResumenPorCliente = async (cliente_id?: number): Promise<ResumenCliente[]> => {
    return handleRequestWithAuth(async () => {
        const url = cliente_id 
            ? `${API_URL}resumen_por_cliente/?cliente_id=${cliente_id}`
            : `${API_URL}resumen_por_cliente/`;
        const response = await axiosInstance.get(url);
        return response.data;
    });
};

// NUEVO: Obtener uso de horas regalo con consumos incluidos
export const fetchUsoHorasRegaloConConsumos = async (id: number): Promise<UsoHorasRegalo> => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.get(`${API_URL}${id}/con_consumos/`);
        return response.data;
    });
};